import { render, staticRenderFns } from "./AddSubempreitada.vue?vue&type=template&id=34dbd3fb"
import script from "./AddSubempreitada.vue?vue&type=script&lang=js"
export * from "./AddSubempreitada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports